import React from 'react';

// Components
import { MenuToggle } from '../../buttons';

// Libraries
import classNames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Dropdown } from 'react-bootstrap';

export interface MenuItem<T extends object> {
  className?: string;

  'data-testid'?: string;
  icon: string;
  key: string;
  value: string | JSX.Element;
  isAllowed: (item: T) => boolean;
  onClick: (item?: T) => void;
}

function TableMenu<T extends object>({
  disabled,
  menuItems,
  psbRef,
}: {
  disabled?: boolean;
  menuItems: MenuItem<T>[];
  psbRef?: React.MutableRefObject<PerfectScrollbar | null>;
}): JSX.Element {
  const renderOptions = (): JSX.Element[] =>
    menuItems.map(item => (
      <Dropdown.Item
        key={item.key}
        role="menuitem"
        as="button"
        data-testid={item['data-testid']}
        className={classNames(item.className)}
        onClick={() => item.onClick()}
      >
        <i className={item.icon} />
        <span>{item.value}</span>
      </Dropdown.Item>
    ));
  // TODO : refactor or create a new version of the MenuToggle
  // explore the idea to create a reusable component when you pass props to it to create a menu list.
  // This code is specific to the Table Menu and we should explore if we can make the MenuToggle easily reusable.

  return (
    <div className="table-menu" onClick={e => e.stopPropagation()}>
      {menuItems.length > 0 && <MenuToggle options={renderOptions()} alignRight psbRef={psbRef} disabled={disabled} />}
    </div>
  );
}

export default TableMenu;
